module.exports = __webpack_public_path__ + "38b7331d30d20db52afc8279165c4ff7.MP3";